import {
  SlOption
} from "./chunk.SA5AOLKA.js";

// src/components/option/option.ts
var option_default = SlOption;
SlOption.define("sl-option");

export {
  option_default
};
